module.exports = "/_next/static/images/21be31b7cfd4c39e8d9e06d31eb9039f-service-payment.png.webp";